export default function PHP_rewinddir() {
  return (
    <div>
      <h1>PHP_rewinddir</h1>
    </div>
  );
}
